<template>
  <div>
    <div class="main-form__info">
      <div class="main-form__left">
        <img
          :src="getImage(client.big_image)"
          alt
          width="100%"
          class="main-uploader__disable-img"
          v-if="!$guard('write', 'Clients')"
        />

        <!-- <label
          v-else
          class="empoyee-form__img"
          :style="[
            client.big_image
              ? { backgroundImage: 'url(' + client.big_image + ')' }
              : {},
          ]"
        >
          <img src="/images/master-photo.png" alt />
          <input
            type="file"
            accept="image/png, image/jpeg, image/jpg"
            @change="updateImg"
            :disabled="!$guard('write', 'Clients')"
          />
        </label>-->
        <div v-else class="main-uploader main-uploader_w210 main-uploader_h216">
          <label
            for="main-uploader__input-file"
            class="main-uploader__file"
            :style="{ backgroundImage: 'url(' + client.big_image + ')' }"
          >
            <img class="main-uploader__icon" src="@/assets/images/addIcon.svg" alt />
            <input
              type="file"
              class="main-uploader__input-file"
              id="main-uploader__input-file"
              @change="updateImg"
              :disabled="!$guard('write', 'Clients')"
            />
          </label>
        </div>
      </div>

      <div class="main-form__right">
        <div
          class="main-form__half main-form__half_first-pr12 main-form__half_mb"
          :data-error="$t('errors.required')"
          :class="{ 'error-input': errors.has('first_name') }"
        >
          <input
            v-model="client.first_name"
            type="text"
            :placeholder="$t('forms.name')"
            :disabled="!$guard('write', 'Clients')"
            v-validate="{ required: true }"
            name="first_name"
            class="main-form__input"
          />
        </div>
        <div
          class="main-form__half main-form__half_first-pl12 main-form__half_mb"
          :data-error="$t('errors.required')"
          :class="{ 'error-input': errors.has('last_name') }"
        >
          <input
            v-model="client.last_name"
            type="text"
            :placeholder="$t('forms.surname')"
            :disabled="!$guard('write', 'Clients')"
            v-validate="{ required: true }"
            name="last_name"
            class="main-form__input"
          />
        </div>

        <div
          class="main-form__half main-form__half_first-pr12 main-form__half_mb"
          :data-error="$t('errors.phone')"
          :class="{ 'error-input': errors.has('phone') }"
        >
          <vue-tel-input
            v-model="client.phone"
            @validate="checkValue"
            :placeholder="$t('forms.phone')"
            :inputOptions="{ showDialCode: true }"
            mode="international"
            class="main-vue-tel-input"
            :defaultCountry="defaultCountry"
            :disabled="!$guard('write', 'Clients')"
          ></vue-tel-input>
        </div>
        <div
          class="main-form__half main-form__half_first-pl12 main-form__half_mb"
          :data-error="$t('errors.required')"
          :class="{ 'error-input': errors.has('email') }"
        >
          <input
            v-model="client.email"
            type="text"
            placeholder="Email"
            :disabled="!$guard('write', 'Clients')"
            v-validate="{ required: true }"
            name="email"
            class="main-form__input"
          />
        </div>

        <div class="main-form__box main-form__box_mb0">
          <div v-for="item in client.addresses" :key="item.id" class="client-address">
            <div style="position: absolute; right: 62px;margin-top:7px; z-index: 3">
              <svg
                @click="openAutocomplete(item)"
                width="20px"
                height="20px"
                id="Capa_1"
                xmlns="http://www.w3.org/2000/svg"
                x="0px"
                y="0px"
                viewBox="0 0 512 512"
                xml:space="preserve"
                fill="var(--menu-text-color)"
              >
                <g>
                  <g>
                    <path
                      d="M256,0C156.748,0,76,80.748,76,180c0,33.534,9.289,66.26,26.869,94.652l142.885,230.257
												c2.737,4.411,7.559,7.091,12.745,7.091c0.04,0,0.079,0,0.119,0c5.231-0.041,10.063-2.804,12.75-7.292L410.611,272.22
												C427.221,244.428,436,212.539,436,180C436,80.748,355.252,0,256,0z M384.866,256.818L258.272,468.186l-129.905-209.34
												C113.734,235.214,105.8,207.95,105.8,180c0-82.71,67.49-150.2,150.2-150.2S406.1,97.29,406.1,180
												C406.1,207.121,398.689,233.688,384.866,256.818z"
                    />
                  </g>
                </g>
                <g>
                  <g>
                    <path
                      d="M256,90c-49.626,0-90,40.374-90,90c0,49.309,39.717,90,90,90c50.903,0,90-41.233,90-90C346,130.374,305.626,90,256,90z
												M256,240.2c-33.257,0-60.2-27.033-60.2-60.2c0-33.084,27.116-60.2,60.2-60.2s60.1,27.116,60.1,60.2
												C316.1,212.683,289.784,240.2,256,240.2z"
                    />
                  </g>
                </g>
                <g />
                <g />
                <g />
                <g />
                <g />
                <g />
                <g />
                <g />
                <g />
                <g />
                <g />
                <g />
                <g />
                <g />
                <g />
              </svg>
            </div>

            <div
              class="main-form__box"
              :data-error="$t('errors.required')"
              :class="{ 'error-input': errors.has('streetAndHouse') }"
              @click="openAutocomplete(item)"
            >
              <input
                :value="
                  `${item.street} ${item.house}, ${item.postcode}, ${item.city}`
                "
                type="text"
                :placeholder="$t('forms.street')"
                v-validate="{ required: true }"
                name="streetAndHouse"
                :disabled="true"
                style="cursor: pointer"
                class="main-form__input"
              />
            </div>

            <div
              class="main-form__box"
              :data-error="$t('errors.required')"
              :class="{ 'error-input': errors.has('apartment') }"
            >
              <input
                v-model="item.apartment"
                type="text"
                :placeholder="'Büro/Apt./Top/Tür'"
                v-validate="{ required: true }"
                name="apartment"
                :disabled="!$guard('write', 'Clients')"
                class="main-form__input"
              />
            </div>

            <div class="main-form__box">
              <input
                v-model="item.description"
                type="text"
                :placeholder="$t('forms.description')"
                :disabled="!$guard('write', 'Clients')"
                class="main-form__input"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="main-form__buttons main-form__buttons_center">
      <!-- <span @click="$emit('close')" class="main-button main-button_cancel">
        {{ $t("global.cancel") }}
      </span>-->
      <button
        class="main-button"
        @click="confirm"
        :class="{
          disableBtn: !$guard('write', 'Clients') || errors.items.length > 0,
          disabled: !isValid,
          disabled_green: !isValid,
        }"
        :disabled="!isValid || !$guard('write', 'Clients')"
      >{{ $t("global.save") }}</button>
    </div>

    <modal :show="showAutocomplete" :showBtn="false" :dark="true" @close="toggleAutocomplete">
      <autocomplete @done="fillAddress" @close="toggleAutocomplete" />
    </modal>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import { checkEmail } from '@/utils/checkEmail'

import autocomplete from '@/components/controls/autocomplete'

export default {
    name: 'mainView',
    components: {
        autocomplete,
    },
    props: {
        client: {
            required: true,
        },
        isUpdate: {
            required: true,
        },
    },
    computed: {
        ...mapGetters({
            showAutocomplete: 'autocomplete/showGetters',
            clientModalType: 'clientModalType',
        }),
        isValid() {
            if (this.client.first_name === '' || this.client.first_name === undefined) {
                return false
            }

            if (this.client.last_name === '' || this.client.last_name === undefined) {
                return false
            }

            if (!this.isValidPhone) {
                return false
            }

            if (
                this.client.email === ''
        || this.client.email === undefined
        || !checkEmail(this.client.email)
            ) {
                return false
            }

            return true
        },
    },
    data() {
        return {
            defaultImage: '/images/default-user.svg',
            addressId: null,
            showAddress: false,
            isValidPhone: false,
            defaultCountry: this.$config.behavior === 'hilfy' ? 'at' : 'de',
        }
    },
    methods: {
        ...mapMutations({
            toggleAutocomplete: 'autocomplete/toggleShow',
            clearClientModal: 'clearClientModal',
            setClientModal: 'setClientModal',
            setState: 'sip/setState',
            setTalkdesk: 'setTalkdesk',
        }),
        ...mapActions({
            updateClient: 'updateClient',
            updateClientImage: 'updateClientImage',
            createClient: 'createClient',
        }),
        getImage(image) {
            return image === null ? this.defaultImage : image
        },
        fillAddress(data) {
            if (this.addressId !== null) {
                this.client.addresses.forEach((element) => {
                    if (element.id === this.addressId) {
                        element.house = data.address.short_name
                        element.street = data.address.route
                        element.longitude = data.location.lng
                        element.latitude = data.location.lat
                        element.postcode = data.address.index
                        element.index = data.address.index
                        element.country = data.address.country
                        element.city = data.address.city
                        element.streetAndHouse = `${data.address.route} ${data.address.short_name}`
                    }
                })
            } else {
                this.client.addresses[0].street = data.address.route
                this.client.addresses[0].house = data.address.short_name
                this.client.addresses[0].streetAndHouse = `${data.address.route} ${data.address.short_name}`
                this.client.addresses[0].apartment = 1
                this.client.addresses[0].postcode = data.address.postcode || ''
                this.client.addresses[0].city = data.addresse.city
                this.client.addresses[0].country = data.addresse.country
            }
        },
        openAutocomplete(item) {
            if (item !== null) {
                this.toggleAutocomplete()
                this.addressId = item.id
            }
        },
        setAvatar(file) {
            const reader = new FileReader()
            reader.readAsDataURL(file)

            reader.addEventListener('load', () => {
                this.client.big_image = reader.result
            })
        },
        updateImg({ target: { files } }) {
            const fd = new FormData()
            fd.append('image', files[0])

            if (this.isUpdate) {
                this.updateClientImage({
                    id: this.client.id,
                    fd,
                })
            }

            this.setAvatar(files[0])
            this.client.imageData = fd
        },
        async doAction() {
            if (this.clientModalType === 'edit') {
                return await this.updateClient()
            } else {
                const response = await this.createClient(this.client)
                const { id } = response.data
                const fd = this.client.imageData

                if (!fd && id !== 'validation_failed') return true
                if (!fd || id === 'validation_failed') return

                return await this.updateClientImage({
                    id,
                    fd,
                })
            }
        },
        confirm(e) {
            e.preventDefault()

            this.$validator.validate().then(async (res) => {
                if (!res || this.showAutocomplete) {
                    return
                }
                this.client.phone = this.client.phone.replace(/\s+/g, '')
                const status = await this.doAction()

                if (!status) {
                    return
                }

                const { title, message } = this.successNotification()

                this.$notify({
                    title,
                    message,
                    duration: 5000,
                })

                await this.$store.dispatch('getClientsData', {})
                this.setClientModal(false)
                this.setTalkdesk(false)
            })
        },

        successTitle() {
            return this.clientModalType === 'edit'
                ? this.$t('notifications.orderUpdated')
                : this.$t('notifications.clientCreated')
        },
        successMessage() {
            return this.clientModalType === 'edit'
                ? this.$t('notifications.orderUpdatedText')
                : this.$t('notifications.clientCreatedDesc')
        },
        successNotification() {
            return {
                title: this.successTitle(),
                message: this.successMessage(),
            }
        },
        checkValue(v) {
            this.isValidPhone = v.valid
        },
    },
}
</script>
